module.exports = __webpack_public_path__ + "images/gradients/gradient-snow.156e08e1a02a05494042.svg";